import { SupportPlan } from '~clients/models';

import { buildSlice, CommonState } from '~libs/reduxUtils';

import { getAll, getAvailableClients, getOne, typePrefix } from '~clients/actions/clientSupportPlans';

import { ClientRow } from '~main/reducers/clients/clients';

interface State extends CommonState<SupportPlan> {
  available_clients: ClientRow[];
}

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  available_clients: [],
};

const slice = buildSlice<State, SupportPlan>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
  customActions: {
    clearSupportPlans(state) {
      state.rows = initialState.rows;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAvailableClients.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      state.available_clients = action.payload.data;
    });
  },
});

export const { clear, updateParams, clearSupportPlans } = slice.actions;
export default slice.reducer;
